import {useEffect, useRef, useState} from "react";
import {pluralForm, useClickOutside} from "../../../utils";
import {postByUrl, putByUrl} from "../../../v3MethodsService";

import {Button} from "primereact/button";
import {InputNumber} from "primereact/inputnumber";
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";
import {Chips} from "primereact/chips";

import loader from './img/loader.svg'

import './style.scss'

const VisionOCR = ({  matchData, formData, visible = false, onClose }) => {
    // const { data: state } = dataRes
    const [state, setState] = useState(null)

    const modalRef = useRef(null)

    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [checkboxes, setCheckboxes] = useState({home: [], away: []})

    useClickOutside(visible, modalRef, onClose)

    useEffect(() => {
        if (!visible) {
            setState(null)
            setData(null)
            setCheckboxes({home: [], away: []})
        }
    }, [visible]);

    useEffect(() => {
        if (formData && matchData && !state) {
            setLoading(true)

            postByUrl("visionOCR", formData, true)
                .then((resp) => {
                    if (resp && resp.success) {
                        setState(resp.data)
                    } else {
                        onClose({ severity: "error", summary: resp.msg || "Не удалось распознать данные" })
                    }
                })
                .finally(() => setLoading(false))
        }
    }, [formData, matchData]);

    useEffect(() => {
        if (state) {
            let homeScore = 0
            let awayScore = 0

            if (state.normalizedData && state.normalizedData.goals) {
                if (state.normalizedData.goals.home && state.normalizedData.goals.home.length > 0) {
                    homeScore = state.normalizedData.goals.home.length
                }

                if (state.normalizedData.goals.away && state.normalizedData.goals.away.length > 0) {
                    awayScore = state.normalizedData.goals.away.length
                }
            }

            setData({
                score: {home: homeScore, away: awayScore},
                squads: {...state.normalizedData?.rosters}
            })
        }
    }, [state]);

    const handleCheckbox = (value, side) => {
        if (checkboxes[side].includes(value)) {
            setCheckboxes(prev => ({...prev, [side]: prev[side].filter(c => c !== value)}))
            return
        }
        setCheckboxes(prev => ({...prev, [side]: [...prev[side], value]}))
    }

    const handleCheckboxAll = (value, side) => {
        if (value) {
            setCheckboxes(prev => ({...prev, [side]: data.squads[side].map(r => r._id)}))
            return
        }
        setCheckboxes(prev => ({...prev, [side]: []}))
    }

    const updateChips = (value, player, side) => {
        const newRoster = data.squads[side].map(r => r._id === player._id ? ({...r, minutes: value}) : r)
        setData(prev => ({...prev, squads: {...prev.squads, [side]: newRoster}}))
    }

    const updateRosterData = (value, key, player, side) => {
        const newRoster = data.squads[side].map(r => r._id === player._id ? ({...r, [key]: value}) : r)
        setData(prev => ({...prev, squads: {...prev.squads, [side]: newRoster}}))
    }

    const updateScore = (value, side) => {
        setData(prev => ({...prev, score: {...prev.score, [side]: value}}))
    }

    const deleteHandler = () => {
        const homeRoster = data.squads.home.filter(p => !checkboxes.home.find(c => c === p._id))
        const awayRoster = data.squads.away.filter(p => !checkboxes.away.find(c => c === p._id))

        setCheckboxes({home: [], away: []})
        setData(prev => ({...prev, squads: {home: homeRoster, away: awayRoster}}))
    }

    const handleSave = () => {
        setLoading(true)

        const newData = {
            ...data,
            squads: {
                home: data.squads.home.map(s => ({...s, number: s.number ? s.number.toString() : "", minutes: `${s.minutes.join(", ")}`})),
                away:data.squads.away.map(s => ({...s, number: s.number ? s.number.toString() : "", minutes: `${s.minutes.join(", ")}`}))
            }
        }

        putByUrl(`visionOCR/${matchData?._id}`, newData)
            .then(resp => {
                if (resp && resp.success) {
                    onClose({ severity: "success", summary: `В «${matchData?.home?.name} - ${matchData?.away?.name}» добавлены голы и передачи. Карточки нужно ввести вручную` })
                } else {
                    onClose({ severity: "error", summary: resp.msg || "Ошибка" })
                }
            })
            .finally(() => setLoading(false))
    }

    return visible && (
        <div className='vision__overlay'>
            {loading ? (
                <div className='vision__loader'>
                    Идет обработка данных, <br/>пожалуйста не закрывайте страницу
                    <img src={loader}/>
                </div>
            ) : !!data && (
                <div className='vision' ref={modalRef}>
                    <div className='vision__header'>
                        <h5>Проверьте счет и остальные данные</h5>
                        <i className='pi pi-times' onClick={onClose}/>
                    </div>

                    <div className='vision__content'>
                        <div className='vision__info'>
                            <div className='vision__team'>
                                <span>Хозяева</span>
                                {matchData?.home?.name}
                            </div>
                            <div className='vision__score'>
                                <InputNumber value={data.score.home} onChange={e => updateScore(e.value, 'home')} mode="decimal" showButtons min={0} max={100} className='vision__scoreinput'/>
                                -
                                <InputNumber value={data.score.away} onChange={e => updateScore(e.value, 'away')} mode="decimal" showButtons min={0} max={100} className='vision__scoreinput'/>
                            </div>
                            <div className='vision__team vision__team_away'>
                                <span>Гости</span>
                                {matchData?.away?.name}
                            </div>
                        </div>

                        <div className='vision__squads'>
                            <table className='vision__table'>
                                <thead className='vision__thead'>
                                <tr>
                                    <th>
                                        <Checkbox checked={checkboxes.home.length === data.squads?.home?.length} onChange={e => handleCheckboxAll(e.checked, 'home')}/>
                                    </th>
                                    <th>№</th>
                                    <th>Фамилия имя</th>
                                    <th>Голы</th>
                                    <th>Минуты</th>
                                    <th>Пасы</th>
                                </tr>
                                </thead>
                                <tbody className='vision__tbody'>
                                {data.squads?.home?.map((r, k) => {
                                    const isRed = !!((r.number == null || r.name == null) && r.minutes?.length > 0)

                                    return (
                                        <tr key={k}
                                            className={isRed ? "vision__tr_red" : ''}>
                                            <td>
                                                <Checkbox value={r._id} checked={checkboxes.home.includes(r._id)} onChange={e => handleCheckbox(e.value, 'home')}/>
                                            </td>
                                            <td className={isRed && r.number == null ? "vision__td_red" : ''}>
                                                <InputText value={r.number || 0} onChange={e => updateRosterData(e.target.value, 'number', r, 'home')} keyfilter="int" maxLength={2} className='vision__inputtext'/>
                                            </td>
                                            <td className={isRed && r.name == null ? "vision__td_red" : ''}>
                                                {r.name || "-"}
                                            </td>
                                            <td>
                                                <InputNumber value={r.goals || 0} onChange={e => updateRosterData(e.value, 'goals', r, 'home')} mode="decimal" min={0} className='vision__inputnumber'/>
                                            </td>
                                            <td>
                                                <Chips value={r.minutes} keyfilter="num" className="vision__chips" onChange={e => updateChips(e.value, r, 'home')}/>
                                            </td>
                                            <td>
                                                <InputNumber value={r.assists || 0} onChange={e => updateRosterData(e.value, 'assists', r, 'home')} mode="decimal" min={0} className='vision__inputnumber'/>
                                            </td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>

                            <table className='vision__table'>
                                <thead className='vision__thead'>
                                <tr>
                                    <th>
                                        <Checkbox checked={checkboxes.away.length === data.squads?.away?.length} onChange={e => handleCheckboxAll(e.checked, 'away')}/>
                                    </th>
                                    <th>№</th>
                                    <th>Фамилия имя</th>
                                    <th>Голы</th>
                                    <th>Минуты</th>
                                    <th>Пасы</th>
                                </tr>
                                </thead>
                                <tbody className='vision__tbody'>
                                {data.squads?.away?.map((r, k) => {
                                    const isRed = !!((r.number == null || r.name == null) && r.minutes?.length > 0)

                                    return (
                                        <tr key={k} className={isRed ? "vision__tr_red" : ''}>
                                            <td>
                                                <Checkbox value={r._id} checked={checkboxes.away.includes(r._id)} onChange={e => handleCheckbox(e.value, 'away')}/>
                                            </td>
                                            <td className={isRed && r.number == null ? "vision__td_red" : ''}>
                                                <InputText value={r.number || 0} onChange={e => updateRosterData(e.target.value, 'number', r, 'away')} keyfilter="int" maxLength={2} className='vision__inputtext'/>
                                            </td>
                                            <td className={isRed && r.name == null ? "vision__td_red" : ''}>
                                                {r.name || "-"}
                                            </td>
                                            <td>
                                                <InputNumber value={r.goals || 0} onChange={e => updateRosterData(e.value, 'goals', r, 'away')} mode="decimal" min={0} className='vision__inputnumber'/>
                                            </td>
                                            <td>
                                                <Chips value={r.minutes} keyfilter="num" className="vision__chips" onChange={e => updateChips(e.value, r, 'away')}/>
                                            </td>
                                            <td>
                                                <InputNumber value={r.assists || 0} onChange={e => updateRosterData(e.value, 'assists', r, 'away')} mode="decimal" min={0} className='vision__inputnumber'/>
                                            </td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='vision__footer'>
                        <Button label={`Удалить ${checkboxes.home.length + checkboxes.away.length} игрок${pluralForm(checkboxes.home.length + checkboxes.away.length, ['', 'а', 'ов'])}`} onClick={deleteHandler} className={`vision__button vision__button_red ${(checkboxes.home.length + checkboxes.away.length) > 0 ? '' : 'vision__button_invis'}`}/>
                        <div className='vision__btn-group'>
                            <Button label='Не сохранять' onClick={onClose} className='vision__button vision__button_text'/>
                            <Button label='Сохранить' onClick={handleSave} className='vision__button'/>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default VisionOCR;